<template>
    <fieldset class="form-fieldset" :class="containerClass">
        <slot />
    </fieldset>
</template>
<script>
export default {
    props: {
        error: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        /**
         * Compute container classes.
         *
         * @returns {object} Container classes.
         */
        containerClass() {
            return {
                error: this.error,
            };
        },
    },
};
</script>
